module.exports = __webpack_public_path__ + "img/2025big22.7576124e.jpg";